import { Injectable } from '@angular/core';
import { DocPayants } from '../../models/DocPayants';
import { DocPrix } from '../../models/DocPrix';
import { InfosSup } from '../../models/InfosSup';
import { Oui } from '../../models/Oui';

@Injectable({
  providedIn: 'root'
})
export class InfosSupService {

  constructor() {
  }

  getInfosSup(controls: any) {
    const infosSup = new InfosSup();
    infosSup.conditionsModePaiement = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_InfosSup_SepAtt_conditionsModePaiement'));
    const dateLimiteObtention = '_SepSep_Initial_SepSep_InfosSup_SepAtt_dateLimiteObtention';
    infosSup.dateLimiteObtention = this.sanitizeString(controls.get(dateLimiteObtention));
    infosSup.docPayants = new DocPayants();
    infosSup.docPayants.non = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_InfosSup_SepSep_DocPayants_SepAtt_non'));
    infosSup.docPayants.oui = new Oui();
    infosSup.docPayants.oui.docPrix = new DocPrix();
    infosSup.docPayants.oui.docPrix.devise = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_InfosSup_SepSep_DocPayants_SepSep_Oui_SepSep_DocPrix_SepAtt_devise'));
    infosSup.docPayants.oui.docPrix.value = controls.get('_SepSep_Initial_SepSep_InfosSup_SepSep_DocPayants_SepSep_Oui_SepSep_DocPrix_SepAtt_value');
    return infosSup;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
